import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { COMPANY_INFO } from '../data/siteData';

export default function ThankYouPage() {
  return (
    <>
      <SEO
        title="Tak - Hærvejens Træpleje"
        description="Vi har modtaget din henvendelse og kontakter dig hurtigst muligt."
        canonical="https://xn--hrvejenstrpleje-xlbj.dk/tak/"
      />

      <Breadcrumbs items={[{ label: 'Tak' }]} />

      <section className="py-20 sm:py-28 max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <div className="w-20 h-20 bg-[#e4eee8] text-[#1b4332] rounded-full flex items-center justify-center mx-auto mb-6 text-3xl shadow-xs">
          <i className="fa-solid fa-circle-check" aria-hidden="true" />
        </div>

        <h1 className="text-3xl sm:text-5xl font-bold text-[#102419] mb-4">
          Tak for din henvendelse
        </h1>

        <p className="text-lg text-[#324538] mb-6 font-medium">
          Vi har modtaget din henvendelse og kontakter dig hurtigst muligt
        </p>

        <div className="bg-white p-6 sm:p-8 rounded-2xl border border-[#dce5df] shadow-xs text-sm sm:text-base text-[#3d5044] space-y-3 mb-8">
          <p>
            Du er også velkommen til at ringe eller sende en sms til{' '}
            <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="font-bold text-[#1b4332] underline whitespace-nowrap">
              {COMPANY_INFO.phone}
            </a>
            .
          </p>
          <p>
            Vores e-mail:{' '}
            <a href={`mailto:${COMPANY_INFO.email}`} className="font-bold text-[#1b4332] underline whitespace-nowrap">
              {COMPANY_INFO.email}
            </a>{' '}
            bliver også løbende kontrolleret og besvaret.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 max-w-xs sm:max-w-none mx-auto">
          <Link
            to="/"
            className="w-full sm:w-auto text-center px-6 py-3.5 rounded-xl bg-[#1b4332] text-white font-semibold text-sm hover:bg-[#143627] transition-colors"
          >
            Tilbage til forsiden
          </Link>
          <Link
            to="/services"
            className="w-full sm:w-auto text-center px-6 py-3.5 rounded-xl border border-[#2d6a4f] text-[#1b4332] font-semibold text-sm hover:bg-[#f2f7f4] transition-colors"
          >
            Se vores ydelser
          </Link>
        </div>
      </section>
    </>
  );
}
